import { render, staticRenderFns } from "./CourseClass.vue?vue&type=template&id=1c281436&scoped=true"
import script from "./CourseClass.vue?vue&type=script&lang=js"
export * from "./CourseClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c281436",
  null
  
)

export default component.exports